import { inject, Injectable } from "@angular/core";
import { IntegrationService } from "src/app/services/integration.service";
import { CanActivate } from "@angular/router";
import { log } from "src/app/common/logger";

const logger = log("ProvideIntegrationsGuard");

@Injectable()
export class ProvideIntegrationsGuard implements CanActivate {
  private readonly integrationService = inject(IntegrationService);

  async canActivate(): Promise<boolean> {
    logger.info("canActivate");

    await this.integrationService.init();
    return true;
  }
}
